'use strict';

var formValidation = require('../components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
const { selectIso } = require('../phoneRegex');
const { FormInputRegex } = require('../FormRegex');
const { validateEmailForm } = require('../validateEmailForm');

var showAccountCreationForm = function () {
    $.ajax({
        type: 'POST',
        url: $(".show-customer-form").data('url'),
        datatype: 'json',
        data: {
            email: $('#email-guest').val()
        },
        success: function (response) {
            if (!response.error) {
                $('.form-content').html(response.formHTML);
                login.initRegistrationForm();
            }
        }
    });
}

var submitCheckEmail = function (data) {
    $.ajax({
        type: 'POST',
        url: $(login.checkEmailFormSelector).attr('action'),
        datatype: 'json',
        data: data,
        success: function (data) {
            login.handleErrors(data.message)
            if (!data.error) {
                login.renderHtml(data.formHTML);
            }
            //registration from ==> bind events
            if (data.code == 4321) {
                login.initRegistrationForm();
            }
        },
        error: function (error) {
            $('.btn-loader .loading').addClass('no-load');
            $('.login-page .invalid-feedback').empty();
            var invalidFeedbackEmail = $('.invalid-feedback-email');
            if (invalidFeedbackEmail.text().trim() === '') {
                var errorMessage = $('.login-page').data('captcha-error');
                $('#check-email-input-error').empty().append(errorMessage);
                $('.form-content .check-email').addClass('email-checked');
            }
        }
    });
};

var submitLogin = function (form, formData) {
    var url = form.attr('action');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: formData,
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                $('#form-password-error').empty().append(data.error[0]);
            } else {
                $('form.login').trigger('login:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (data) {
            if (data.responseJSON && data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                $('form.login').trigger('login:error', data);
                form.spinner().stop();
                $('.login-page .invalid-feedback').empty();
                var errorMessage = $('.login-page').data('captcha-error');
                $('.error-captcha-message').empty().append(errorMessage);
                $('.form-content .check-email').addClass('email-checked');
            }
        }
    });
}
function submitRegister(form, formData) {
    var url = form.attr('action');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: formData,
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                $('form.registration').trigger('login:register:error', data);
                formValidation(form, data);
            } else {
                $('form.registration').trigger('login:register:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            $('form.registration').trigger('login:register:error', err);
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
            }

            form.spinner().stop();
        }
    });
};

var login = {
    formsContainer: $(".form-container"),
    errorsContainer: $(".form-errors-container"),
    checkEmailFormSelector: "form#check-email-form",
    loginFormSelector: 'form.login',
    registerFormSelector: 'form.registration',
    handleErrors: function (errors = null) {
        if (!errors) {
            login.errorsContainer.html("");
        } else if (Array.isArray(errors)) {
            login.errorsContainer.empty();
            $.each(errors, function (index, errorHtml) {
                login.errorsContainer.append(errorHtml)
            })
        } else {
            $('.check-email-submit-form .invalid-feedback').html(errors);
            $('.btn-loader .loading').addClass('no-load');
        }
    },
    renderHtml: function (html) {
        login.formsContainer.html(html);
    },
    checkEmail: function () {
        $('.btn-loader .loading').removeClass('no-load');
        var formData = {
            csrf_token: $("input[name='csrf_token']").val(),
            email: $('#check-email-input').val() ? $('#check-email-input').val() : ''
        };
        if (window.sitePreferences.RECAPTCHA_V3_ENABLED) {
            grecaptcha.ready(function () {
                grecaptcha.execute(sitePreferences.RECAPTCHA_SITE_KEY, {
                    action: 'submit'
                }).then(function (token) {
                  formData.reCaptchatoken = token;
                    submitCheckEmail(formData);
                }).catch(function (error) {
                    // Gestion de l'erreur du captcha
                    $('.login-page .invalid-feedback').empty();
                    var errorMessage = $(".login-page").data("captcha-error");
                    $('.error-captcha-message').empty().append(errorMessage);
                });
            });
        } else {
            submitCheckEmail(formData);
        }
    },
    initRegistrationForm: function () {
        $('#dwfrm_profile_byEmail').on('click', function () {
            if ($('#dwfrm_profile_byEmail').is(':checked')) {
                $('#dwfrm_profile_civility_1').attr('required', true);
                $('#radio-buttons').removeClass("hide")
                $('#radio-buttons').addClass("skp-gender-radio")
            } else {
                $('#dwfrm_profile_civility_1').removeAttr('required')
                $('#radio-buttons').addClass("hide");
                $('#radio-buttons').removeClass("skp-gender-radio")
                $('#dwfrm_profile_civility_1').removeAttr('aria-required')
            }
        });

        $("#radio-buttons").on("chicked", function () {
            $('#radio-buttons').addClass('skp-gender-radio');
        });

        var dateDropdownsOptions = {
            submitFieldName: 'skp-select-date',
            defaultDateFormat: 'dd/mm/yyyy',
            submitFormat: 'unix',
            defaultDateFormat: 'unix',
            daySuffixes: false,
            dayLabel: "DD",
            monthLabel: "MM",
            yearLabel: "YYYY",
            dayLabel: window.Resources.LABEL_DAY,
            monthLabel: window.Resources.LABEL_MONTH,
            yearLabel: window.Resources.LABEL_YEAR,
            monthLongValues: [
                window.Resources.LABEL_MONTHS_JANUARY,
                window.Resources.LABEL_MONTHS_FEBRUARY,
                window.Resources.LABEL_MONTHS_MARCH,
                window.Resources.LABEL_MONTHS_APRIL,
                window.Resources.LABEL_MONTHS_MAY,
                window.Resources.LABEL_MONTHS_JUNE,
                window.Resources.LABEL_MONTHS_JULY,
                window.Resources.LABEL_MONTHS_AUGUST,
                window.Resources.LABEL_MONTHS_SEPTEMBER,
                window.Resources.LABEL_MONTHS_OCTOBER,
                window.Resources.LABEL_MONTHS_NOVEMBER,
                window.Resources.LABEL_MONTHS_DECEMBER
            ]
        }
        
        if ($('#skp-select-date').data("birthdateday") && $('#skp-select-date').data("birthdatemonth") && $('#skp-select-date').data("birthdateyear")) {
            let birthday = new Date(
                parseInt($('#skp-select-date').data("birthdateyear")), 
                parseInt($('#skp-select-date').data("birthdatemonth")), 
                parseInt($('#skp-select-date').data("birthdateday"))
            );
            dateDropdownsOptions.defaultDate = Math.floor(birthday.valueOf() / 1000);
        }

        $("#skp-select-date").dateDropdowns(dateDropdownsOptions);

        selectIso();

        $('.date-dropdowns .day').on('change', function () {
            var valSelect = $(".date-dropdowns .day");
            if (valSelect[0].selectedIndex === 0)
            {
                valSelect.removeClass('color-black');
            } else {
                valSelect.addClass('color-black');
            }
        });

        $('.date-dropdowns .month').on('change', function () {
            var valSelect = $(".date-dropdowns .month");
            if (valSelect[0].selectedIndex === 0)
            {
                valSelect.removeClass('color-black');
            } else {
                valSelect.addClass('color-black');
            }
        });

        $('.date-dropdowns .year').on('change', function () {
            var valSelect = $(".date-dropdowns .year");
            if (valSelect[0].selectedIndex === 0)
            {
                valSelect.removeClass('color-black');
            } else {
                valSelect.addClass('color-black');
            }
        });

    },
    submitGuestCustomer: function(){
        var customerForm=$('#guest-customer');
        $.ajax({
            url: customerForm.attr('action'), 
            type: 'post',
            data: customerForm.serialize(),
            success: function (data) {
                window.location.href = data.redirectUrl;
            },
            error: function (err) {
              console.log("error")
            }
        });
    },
    init: function () {
        $(document).on("submit", login.checkEmailFormSelector, function (e) {
            e.preventDefault();
            login.checkEmail();
        });
        //guest
        $(document).on('click', '.submit-customer', function (e) {
            e.preventDefault();
            login.submitGuestCustomer()
        });

        //login
        $(document).on("submit", login.loginFormSelector, function (e) {
            var form = $(this),
                formPassword = form.find('.form-alert'),
                titleError= form.find('.title-error').data('title-error');
            e.preventDefault();
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            var formData = form.serialize();
            if (window.sitePreferences.RECAPTCHA_V3_ENABLED) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(sitePreferences.RECAPTCHA_SITE_KEY, {
                        action: 'submit'
                    }).then(function (token) {
                        formData = [formData, $.param({ reCaptchatoken: token })].join('&');
                        submitLogin(form, formData);
                    }).catch(function (error) {
                    // Gestion de l'erreur du captcha
                      form.spinner().stop();
                      $('.login-page .invalid-feedback').empty();
                      var errorMessage = $(".login-page").data("captcha-error");
                      $('.error-captcha-message').empty().append(errorMessage);
                    });
                });
            } else {
                submitLogin(form, formData)
            }

            return false;
        });

        $(document).on("click", ".js-close-btn", function(e){
            $('.alert-password').hide();
        });

        //register:
        $(document).on("submit", login.registerFormSelector, function (e) {
            var form = $(this);
            e.preventDefault();
            form.spinner().start();
            $('form.registration').trigger('login:register', e);
            var formData = form.serialize();
            if (window.sitePreferences.RECAPTCHA_V3_ENABLED) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(sitePreferences.RECAPTCHA_SITE_KEY, {
                        action: 'submit'
                    }).then(function (token) {
                        formData = [formData, $.param({ reCaptchatoken: token })].join('&');
                        submitRegister(form, formData);
                    }).catch(function (error) {
                    // Gestion de l'erreur du captcha
                        form.spinner().stop();
                        $('.login-page .invalid-feedback').empty();
                        var errorMessage = $('.login-page').data('captcha-error');
                        $('.error-captcha-message').empty().append(errorMessage);
                    });
                });
            } else {
                submitRegister(form, formData);
            }
            
            return false;
        });

        $(document).on("submit",'.reset-password-form',function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="' +
                                    data.returnUrl +
                                    '" class="btn btn-primary d-none">' +
                                    data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });

    },
}

FormInputRegex();

$(document).on("click", ".show-customer-form", function (e) {
    showAccountCreationForm();
});

$('#check-email-input').on('input', function(){
    $('#check-email-input-error').empty();
});

module.exports = login.init;

validateEmailForm();